appSocial.service('SocialActionService', [
    'SocialUtils', 'SocialAPIService', 'SocialInitService', 'SocialUserService', 'SocialTypes', 'API', 'UserService', 'UserControl',
    'constants', 'ErrorService', '$ionicLoading',
    function (SocialUtils, SocialAPIService, SocialInitService, SocialUserService, SocialTypes, API, UserService, UserControl,
              Const, ErrorService, $ionicLoading) {

        const {AccountType, CopyAction} = SocialTypes;

        class SocialActionService {
            constructor() {
                /**
                 * @type {SocialAPIService}
                 */
                this.api = SocialAPIService;

                /**
                 * @type {SocialUserService}
                 */
                this.userService = SocialUserService;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                /**
                 * @type {API}
                 */
                this.newforexAPI = API;

                /**
                 * @type {UserService}
                 */
                this.newforexUserService = UserService;

                /**
                 * @type {SocialInitService}
                 */
                this.initService = SocialInitService;

                /**
                 * @type {UserControl}
                 */
                this.newforexUserControlService = UserControl;

                /**
                 * @type {CardAction}
                 */
                this.lastAction = undefined;


                this.$ionicLoading = $ionicLoading;
            }

            /**
             * @param {CardAction} cardAction
             */
            copy(cardAction) {
                const traderId = cardAction.trader.id;
                this.lastAction = undefined;
                // clear back state
                this.utils.clearHistory();
                return this.utils.navigate('root.app.socialCopy', {id: traderId});
            }

            register() {
                const user = this.newforexUserService.get();

                const request = {
                    email: user.email,
                    userName: `user.0.${user.activeTradingAccount.source}.${user.activeTradingAccount.login}`,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    source: Const.platformById.web,
                    country: user.country,
                    currency: user.activeTradingAccount.currency
                }

                this.$ionicLoading.show();

                return this.newforexAPI.socialRegister(request)
                    .then(response => this.checkResponse(response))
                    .then(() => {
                        return this.initService.restart()
                    })
                    .then(() => {
                        this.$ionicLoading.hide();
                        // run saved action
                        if (this.lastAction) {
                            console.log('run saved action', this.lastAction);
                            this.copy(this.lastAction);
                        }
                    })
                    .catch(error => {
                        this.$ionicLoading.hide();
                        console.warn(error);
                        return this.utils.navigate('root.app.socialCrash');
                    })
            }

            /**
             * Entry point of all actions
             * @param {CardAction} cardAction
             * @return {void | Promise<void>}
             */
            stateCheck(cardAction) {
                // save action and trader
                this.lastAction = cardAction;

                /**
                 * @type {UserModel}
                 */
                const user = this.newforexUserService.get();
                const socialUser = this.userService.get();

                if (socialUser.id) {
                    return this.copy(cardAction);
                }

                if (!user.activeTradingAccount) {
                    // create account and go to registration
                    return this.utils.navigate(this.newforexUserControlService.getState());
                }

                if (!user.activeTradingAccount.live) {
                    // no live account or only demo account exists

                    // show popup here
                    return this.utils.navigate('root.app.socialCrash', {
                        err: JSON.stringify({
                            textTitle: 'You are currently trading on a Demo account',
                            textContent: 'Please switch to a Live account ',
                            actionText: 'Switch Account',
                            back: 'root.app.manageAccounts'
                        })
                    })
                }

                // go to registration state
                return this.utils.navigate('root.app.socialRegistration')
            }


            checkResponse(response, request) {
                console.log(response)
                if (!response.status === 0) {
                    throw new ErrorService({
                        source: 'SocialActionService',
                        type: Const.error.type.VALIDATION,
                        severity: 'warning',
                        code: response.code || 'general_error',
                        data: {
                            request: request,
                            response: response
                        }
                    })
                }
                return response;
            }


            callAction(action, trader) {
                const {StopCopy, AddFunds, RemoveFunds, Pause, Resume, SetStopLoss} = CopyAction;

                switch (action) {
                    case AddFunds:
                    case RemoveFunds:
                    case SetStopLoss:
                        return this.utils.navigate('root.app.socialFunds', {id: trader.id, action})
                    case Pause:
                    case Resume:
                        return this.utils.navigate('root.app.socialPause', {id: trader.id, action})
                    case StopCopy:
                        return this.utils.navigate('root.app.socialCopy', {id: trader.id, action})
                }
            }

        }


        return new SocialActionService()
    }])


/**
 * @typedef {Object} CardAction
 * @property {Trader} trader
 * @property {CopyAction} action
 */
